import React from 'react';
import './styles.css';
import { PortalHeader, LanguageCurrencyPicker } from '@dmm/lib-react-ui-components';
import { useTPPServices } from '../../tppServices/tppDIHooks';
import { useHeaderSearch } from './hooks/headerSearch';
import { useIntl } from 'react-intl';
import { getMessages } from '../../tppServices/translations/messages';
import { useNavLinksHelper } from '../../utils/navLinksHelper';
import { useCurrencyPicker } from './hooks/useCurrencyPicker';
import { useLayoutContext } from '../../layouts/LayoutUtils/LayoutContext';
import { useHistory, useLocation, useRouteMatch } from 'react-router';

const HeaderLuxury = () => {
  const intl = useIntl();
  const {pageType} = useLayoutContext();
  const match = useRouteMatch();
  const location = useLocation();
  const history = useHistory();
  const { formatMessage: t } = intl;
  const messages = getMessages();
  const searchTitle = t(messages.searchTitle);
  const notFoundText =  t(messages.radius.locationPlaceholder);
  const headerPickerMessages = {
    settings: t(messages.header.settings),
    saveAndClose: t(messages.header.saveAndClose),
    language: t(messages.header.language),
    currency: t(messages.header.currency),
  };

  const { preparedNavLinks } = useNavLinksHelper();
  const { routesConstants, tpp, boatsConstants } = useTPPServices();
  const { searchBox, onSubmitSearch } = useHeaderSearch(searchTitle,  notFoundText, match);
  const { languageCurrencyPickerProps } = useCurrencyPicker({tpp, location, pageType, history, boatsConstants, match, headerPickerMessages});

  return (
    <div className="luxury-header">
      <form action="." onSubmit={onSubmitSearch}>
        <PortalHeader
          menuHeaderTitle={t(messages.header.welcomeMessage)}
          navigationLinks={preparedNavLinks}
          searchBox={searchBox}
          portalLogoLink={routesConstants.HOME_URL_ROOT}
          desktopEndContainer={<LanguageCurrencyPicker {...languageCurrencyPickerProps} />}
          languageCurrencyPicker={languageCurrencyPickerProps}
        />
      </form>
    </div>
  );
};

export default HeaderLuxury;
